export default __webpack_public_path__ + "static/media/icon-profile.3a7ec974.svg";